"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridTokens = exports.Width = exports.Radius = exports.Padding = exports.BorderColor = exports.BackgroundColor = void 0;
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var BackgroundColor = exports.BackgroundColor = /*#__PURE__*/function (BackgroundColor) {
  BackgroundColor["default"] = "default";
  BackgroundColor["grey"] = "grey";
  return BackgroundColor;
}({});
var BorderColor = exports.BorderColor = /*#__PURE__*/function (BorderColor) {
  BorderColor["default"] = "default";
  BorderColor["hover"] = "hover";
  return BorderColor;
}({});
var Radius = exports.Radius = /*#__PURE__*/function (Radius) {
  Radius["default"] = "default";
  Radius["standard"] = "standard";
  return Radius;
}({});
var Padding = exports.Padding = /*#__PURE__*/function (Padding) {
  Padding["default"] = "default";
  return Padding;
}({});
var Width = exports.Width = /*#__PURE__*/function (Width) {
  Width["default"] = "default";
  Width["thick"] = "thick";
  return Width;
}({});
var gridTokens = exports.gridTokens = {
  cell: {
    default: {
      background: _tokens.default.sky.sys.color.background.neutral['1'],
      textColor: _tokens.default.sky.sys.color.text.content.main
    },
    locked: {
      textColor: _tokens.default.sky.sys.color.text.content.auxiliary
    },
    hover: {
      default: _tokens.default.sky.comp.table.color.background.defaultcell.hover,
      locked: _tokens.default.sky.sys.color.background.neutral['2']
    }
  },
  border: {
    width: {
      default: _tokens.default.sky.sys.size.borderwidth.thin,
      thick: _tokens.default.sky.sys.size.borderwidth.thick
    },
    color: {
      default: _tokens.default.sky.sys.color.border.disabled,
      hover: _tokens.default.sky.sys.color.border.active
    },
    radius: {
      default: 0,
      standard: _tokens.default.sky.sys.size.borderradius['2']
    }
  },
  background: {
    color: {
      default: _tokens.default.sky.sys.color.background.neutral['1'],
      grey: _tokens.default.sky.sys.color.background.neutral['2']
    }
  },
  padding: {
    default: _tokens.default.sky.sys.spacing['200']
  }
};